import { Col } from '@amzn/stencil-react-components/layout';
import { H1, Text } from '@amzn/stencil-react-components/text';

import { useMessages } from '../../shared/i18n/useMessages';

const PAGE_BUNDLE = 'features.audit-whiz.translations.reviewQuestions';

type PageKey = 'pageTitle' | 'comingSoon';

/**
 * "Review & publish Astra questions" screen (AuditWhiz WHIZ-002).
 *
 * Phase 1 shell — this is a placeholder that the generate flow navigates to.
 * The full review layout (Astra questions side panel + 3-step wizard) is built
 * incrementally in follow-up changes. Rendered on desktop through `V2Adapter`
 * (see AppRouter.tsx), which supplies the Stencil, i18n, and auth providers.
 */
export function ReviewQuestionsPage(): JSX.Element {
  const { t } = useMessages<PageKey>(PAGE_BUNDLE);

  return (
    <Col
      gridGap="dimensions.spacing.300"
      width="100%"
      padding={{
        top: 'dimensions.spacing.300',
        bottom: 'dimensions.spacing.600',
      }}
      data-testid="review-questions-page"
    >
      <H1>{t('pageTitle')}</H1>
      <Text color="color.text.secondary">{t('comingSoon')}</Text>
    </Col>
  );
}
